import { Chip, Stack, type SxProps, Typography } from "@mui/material";
import React from "react";

interface ColoredChipProps {
  text: string;
  variant?: "filled" | "outlined";
  icon?: React.ReactElement;
  radius?: "sm" | "md" | "lg" | "xl";
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";

  sx?: SxProps;
}

const radiuToBorderRadius = (radius: string) => {
  // Base md = 6px
  switch (radius) {
    case "sm":
      return "2px";
    case "md":
      return "6px";
    case "lg":
      return "8px";
    case "xl":
      return "12px";
    default:
      return "6px";
  }
};

export const ColoredChip = ({
  variant,
  text,
  color,
  radius,
  sx,
  icon,
}: ColoredChipProps) => {
  return (
    <Chip
      size="small"
      variant={variant}
      sx={{
        borderRadius: radiuToBorderRadius(radius ?? "md"),
        ...sx,
      }}
      label={
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {icon && React.cloneElement(icon, { sx: { fontSize: 14 } })}
          <Typography variant="body2" fontWeight="500">
            {text}
          </Typography>
        </Stack>
      }
      color={color}
    />
  );
};
